// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.1_@rspack+core@1.4.1_@swc+helpers@0.5.17__webpack@5.106.2_@swc+core@1.9._f0a897444ed1776bcf0ef2d2e5569f03/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.1_@rspack+core@1.4.1_@swc+helpers@0.5.17__webpack@5.106.2_@swc+core@1.9._f0a897444ed1776bcf0ef2d2e5569f03/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-scrollbar::-webkit-scrollbar {
  display: none;
}

.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.spin {
    animation: spinkf 1s linear infinite;
}

@keyframes spinkf {
    0%   {
        margin-top: 0;
    }
    50%   {
        margin-top: -10px;
    }
    100%   {
        margin-top: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/global.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".no-scrollbar::-webkit-scrollbar {\n  display: none;\n}\n\n.no-scrollbar {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n\n.spin {\n    animation: spinkf 1s linear infinite;\n}\n\n@keyframes spinkf {\n    0%   {\n        margin-top: 0;\n    }\n    50%   {\n        margin-top: -10px;\n    }\n    100%   {\n        margin-top: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
